import { useEffect, useContext, useState } from "react";
import Link from "next/link";

import { GlobalContext } from "@/contexts/GlobalContext";

import styles from "@/styles/footer.module.scss";

const Footer = () => {
    const { globalState: { vhInfo } } = useContext(GlobalContext);
    const [partsLink, setPartsLink] = useState<string>("/car-parts");

    useEffect(() => {
        if (vhInfo) {
            const make = vhInfo?.MAKE.toLowerCase().replace(/\s+|,\s/g, "-");
            const model = vhInfo?.MODEL1.toLowerCase().replace(/\s+|,\s/g, "-");

            setPartsLink(`/car-parts/${make}/${model.replace(/\//g, "-")}/${vhInfo.KCODE_B}/`);
        }
    }, [vhInfo]);

    return (
        <footer className={styles["footer"]}>
            <div className={styles["container"]}>
                <div className={styles["links"]}>
                    <div className={styles["relevant-links"]}>
                        <Link href="/">
                            Home
                        </Link>

                        <Link href={partsLink}>
                            Car Parts
                        </Link>

                        <Link href="/cart">
                            Basket
                        </Link>

                        <Link href="/search">
                            Search Parts
                        </Link>

                        <Link href="/blog">
                            Blog
                        </Link>

                        <Link href="/about">
                            About
                        </Link>

                        <Link href="/contact-us">
                            Contact Us
                        </Link>

                        <Link href="/terms">
                            Terms &amp; Conditions
                        </Link>

                        <Link href="/shipping">
                            Shipping Policy
                        </Link>

                        <Link href="/returns">
                            Returns Policy
                        </Link>
                    </div>
                </div>

                <div className={styles["contact"]}>
                    <span className={styles["address"]}>2-4 Carey Road</span>
                    <span className={styles["address"]}>Bulwell, Nottingham</span>
                    <span className={styles["address"]}>NG6 8AT</span>
                    <a className={styles["email"]} href={`mailto:info@doctorcarparts.com`}>info@doctorcarparts.com</a>
                    <a className={styles["phone"]} href={`tel:01157270786`}>0115 727 0786</a>
                </div>
                <div className={styles["copyright"]}>
                    © {new Date().getFullYear()}
                    <Link href="/">
                        Doctor Car Parts
                    </Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
